import { render } from "./RegisterView.vue?vue&type=template&id=4b26a820&ts=true"
import script from "./RegisterView.vue?vue&type=script&lang=ts"
export * from "./RegisterView.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__